module.exports = __webpack_public_path__ + "img/banner3.68546426.png";